import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { MerchantTitle } from 'app/MerchantTitle';
import { ActivateForm } from 'components/user/ActivateForm';
import { getUserId } from 'components/user/localAuth';
import { User } from 'components/user/model/User';
import { MuiAppBar } from 'lib/appbar/MuiAppBar';
import { useLocalHistory } from 'lib/useLocalHistory';
import { ROUTES } from './routes';

export const ActivatePage: React.FC = () => {
    const { t } = useTranslation();
    const { push } = useLocalHistory();
    const location = useLocation();
    const locationState = location.state as { user: User };

    const handleBack = React.useCallback(() => {
        if (locationState && locationState.user) {
            push(ROUTES.USER.REGISTER, {}, '', { user: locationState.user, identity: getUserId() });
        }
    }, [locationState, push]);

    return (
        <>
            <MerchantTitle title={t('ONBOARDING_ACTIVATION_TITLE')} />
            <MuiAppBar title={t('ONBOARDING_ACTIVATION_TITLE')} onBack={handleBack} />
            <ActivateForm />
        </>
    );
};
